// src/api/axiosInstance.js
import axios from "axios";
import { getToken } from "./auth";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL + "/api",
});

// Attach token automatically
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear everything
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      // Optional: prevent infinite loop
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
